export const times = {
  blink: 80,
  quick: 130,
  snappy: 210,
  normal: 330,
  relaxed: 485,
  long: 785,
  sloth: 1271,
};
